import React, {  PureComponent } from 'react';
import PropTypes from 'prop-types';
import FeatureBlock from './feature-block';
import ItemBlock from './item-block';
import { createContainer } from '@dbk-legacy/muster/react';


const propTypes = {
  data: PropTypes.array.isRequired,
  key: PropTypes.string
};

class ArticleBlock extends PureComponent{
  constructor(props) {
    super(props);
  }

  render(){
    const dataInfo = this.props.data;
    return(
      <div>
          <FeatureBlock dataInfo={dataInfo}/>
          <ItemBlock dataInfo={dataInfo}/>
      </div>

    );
  }
}

//ArticleBlock.PropTypes = propTypes;

//export default ArticleBlock;

export default createContainer({
  $queries: {
    getInsightsData: {
      $call: 'cioinsights.getData',
    },
    changePage: { $call: 'ui.history.push' },
    app: {
      global:{
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        }
      }
    },

    cioinsights: {
      articleList : true
    },
  }
})(ArticleBlock);
